module.exports = __webpack_public_path__ + "img/logo2dd.4f747726.png";